var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, ElementRef, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AttributeFilterService } from 'app/services/attribute-filter.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { CommonTableService } from 'app/services/common-table.service';
import { FieldMappingService } from 'app/services/field-mapping.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { CommonTablePagingComponent } from '../common-datagrid/common-table-paging/common-table-paging.component';
import { A3iService } from 'app/services/a3i.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ContextMenuService } from 'ngx-contextmenu';
import { CommonTemplatesService } from 'app/services/common-templates.service';
var FeatA3iComponent = /** @class */ (function () {
    function FeatA3iComponent(toastr, elemRef, activityService, attrFilterService, attrIndexService, a3iService, commonService, commonTemplateService, contextmenuService, fieldMappingService, gfoService, qcService, mainDataService, mapService, tableService, userService) {
        var _this = this;
        this.toastr = toastr;
        this.elemRef = elemRef;
        this.activityService = activityService;
        this.attrFilterService = attrFilterService;
        this.attrIndexService = attrIndexService;
        this.a3iService = a3iService;
        this.commonService = commonService;
        this.commonTemplateService = commonTemplateService;
        this.contextmenuService = contextmenuService;
        this.fieldMappingService = fieldMappingService;
        this.gfoService = gfoService;
        this.qcService = qcService;
        this.mainDataService = mainDataService;
        this.mapService = mapService;
        this.tableService = tableService;
        this.userService = userService;
        this.sourceRows = [];
        this.resultRows = [];
        this.selectedSourceRows = [];
        this.selectedResultRows = [];
        this.pageSize = 1000;
        this.pageNumber = 1;
        this.tableSorts = [];
        this.isCheckAll = false;
        this.isShowNena = false;
        this.parseCodes = [
            {
                value: 'all',
                label: 'All'
            }, {
                value: 'e',
                label: 'Failure'
            }, {
                value: 's',
                label: 'Success'
            }
        ];
        this.sourceTableId = 'sourceTable';
        this.resultTableId = 'resultTable';
        this.parseCodeCol = 'parse_code';
        this.commentCol = 'comment';
        this.checkCol = 'check';
        this.tableTypeCol = 'tableType';
        this.setCellClass = function (e) {
            var cellClass = _this.tableService.fixedCellClassToString(e.column.info.fixedCellClass);
            if (e.row[_this.resultCol] && e.row[_this.resultCol][_this.parseCodeCol] === 's' && e.column.info.matchingResultCol) {
                var resultVal = e.row[_this.resultCol][e.column.info.matchingResultCol];
                if (!resultVal && !e.value) {
                    //
                }
                else if (resultVal !== e.value) {
                    cellClass += 'qc-error-cell';
                }
            }
            return cellClass;
        };
    }
    FeatA3iComponent.prototype.onToggleCheck = function (idx, row) {
        if (row[this.tableTypeCol] === 'result') {
            this.sourceRows[idx][this.checkCol] = row[this.checkCol];
        }
        else {
            this.resultRows[idx][this.checkCol] = row[this.checkCol];
        }
        this.updateParseDisable();
        this.updateSaveParseDisable();
    };
    FeatA3iComponent.prototype.onToggleCheckAll = function () {
        var _this = this;
        this.sourceRows.forEach(function (r) { return r[_this.checkCol] = _this.isCheckAll; });
        this.resultRows.forEach(function (r) { return r[_this.checkCol] = _this.isCheckAll; });
        this.updateParseDisable();
        this.updateSaveParseDisable();
    };
    FeatA3iComponent.prototype.copyNguid = function (row) {
        var nguid = row[this.nguidCol];
        navigator['clipboard'].writeText(nguid);
    };
    FeatA3iComponent.prototype.filterRowsByParseCode = function () {
        var _this = this;
        var filtered = this.selectedParseCode.value === 'all' ? this.rowsAll : this.rowsAll.filter(function (r) { return r[_this.parseCodeCol] === _this.selectedParseCode.value; });
        this.setRows(filtered);
    };
    FeatA3iComponent.prototype.setSourceColumnsByType = function () {
        this.sourceColumns = this.isShowNena ? this.sourceColumns_nena : this.sourceColumns_legacy;
        this.updateSourceColumnsDisplay();
    };
    FeatA3iComponent.prototype.onSelectRow = function (e, tableType) {
        var _this = this;
        var row = e.selected[0];
        var id = this.a3iService.getRecordId(row);
        if (tableType === 'result') {
            var sourceRow = this.sourceRows.find(function (r) { return _this.a3iService.getRecordId(r) === id; });
            if (sourceRow) {
                this.selectedSourceRows = [sourceRow];
            }
        }
        else if (tableType === 'source') {
            var resultRow = this.resultRows.find(function (r) { return _this.a3iService.getRecordId(r) === id; });
            if (resultRow) {
                this.selectedResultRows = [resultRow];
            }
        }
        this.a3iService.selectedRecordA3iBS.next({
            record: this.selectedSourceRows[0]
        });
    };
    FeatA3iComponent.prototype.onScroll = function (e, syncTableId) {
        if (!e.e.target) {
            return;
        }
        var scrollTop = e.e.target.scrollTop;
        var syncTableBodyElem = this.elemRef.nativeElement.querySelector("#" + syncTableId + " datatable-body");
        syncTableBodyElem.scrollTop = scrollTop;
    };
    FeatA3iComponent.prototype.onActivate = function (e) {
        var _this = this;
        if (e.type === 'mouseenter' && e.row) {
            var id_1 = this.a3iService.getRecordId(e.row);
            this.sourceRows = this.sourceRows.map(function (r) {
                r.isHovering = _this.a3iService.getRecordId(r) === id_1;
                return r;
            });
            this.resultRows = this.resultRows.map(function (r) {
                r.isHovering = _this.a3iService.getRecordId(r) === id_1;
                return r;
            });
        }
    };
    FeatA3iComponent.prototype.onSort = function (e, tableId) {
        this.tableSorts = e.sorts;
        if (tableId === this.resultTableId) {
            this.sourceRows = this.sourceRows.map(function (r) { return r; });
        }
        else if (tableId === this.sourceTableId) {
            this.resultRows = this.resultRows.map(function (r) { return r; });
        }
    };
    FeatA3iComponent.prototype.onContextmenu = function (e) {
        if (e.type === 'body') {
            var event_1 = e.event;
            var item = {
                row: e.content
            };
            this.contextmenuService.show.next({
                event: event_1,
                contextMenu: this.tableContextmenu,
                item: item
            });
            event_1.preventDefault();
            event_1.stopPropagation();
        }
    };
    FeatA3iComponent.prototype.onPaging = function (pageNum) {
        return __awaiter(this, void 0, void 0, function () {
            var isMapFilterOn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pageNumber = pageNum;
                        isMapFilterOn = this.activityService.mapFilterBS.getValue().isOn;
                        if (!isMapFilterOn) return [3 /*break*/, 1];
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getData(pageNum)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FeatA3iComponent.prototype.setRowClass = function (row) {
        if (row.isHovering) {
            return 'hovering-row';
        }
        return;
    };
    FeatA3iComponent.prototype.clearTableData = function () {
        this.sourceRows = [];
        this.resultRows = [];
        this.selectedResultRows = [];
        this.selectedSourceRows = [];
    };
    FeatA3iComponent.prototype.setTablePaging = function (totalNum) {
        this.totalNum = totalNum;
        this.tablePagingComp.reset(1, totalNum);
    };
    FeatA3iComponent.prototype.setRows = function (data) {
        var _this = this;
        if (!data) {
            this.clearTableData();
            return;
        }
        this.sourceRows = data;
        this.sourceRows.forEach(function (i) {
            // table type
            i[_this.tableTypeCol] = 'source';
        });
        this.resultRows = this.sourceRows.map(function (i, idx) {
            var row = Object.assign({}, i);
            row[_this.a3iService.uniqueIdCol] = _this.a3iService.getRecordId(i);
            i[_this.parseCodeCol] = null;
            var result = i[_this.resultCol];
            if (result) {
                Object.keys(result).forEach(function (k) { return row[k] = result[k]; });
                i[_this.parseCodeCol] = result[_this.parseCodeCol];
            }
            // table type
            row[_this.tableTypeCol] = 'result';
            return row;
        });
        this.updateSourceColumnsDisplay();
        this.updateResultColumnsDisplay();
        this.updateParseDisable();
        this.updateSaveParseDisable();
        // Clear selected record
        this.clearSelectedRecord();
    };
    FeatA3iComponent.prototype.clearSelectedRecord = function () {
        this.selectedSourceRows = [];
        this.selectedResultRows = [];
        this.a3iService.selectedRecordA3iBS.next({
            record: null
        });
    };
    FeatA3iComponent.prototype.updateSourceColumnsDisplay = function () {
        var _this = this;
        // this.tableService.updateColumnsSmartDisplay(this.sourceRows, this.sourceColumns);
        setTimeout(function () {
            _this.tableService.extendTableFull(_this.elemRef, _this.sourceTableId, _this.sourceColumns, true);
            _this.sourceColumns = _this.sourceColumns.map(function (i) { return i; });
        });
    };
    FeatA3iComponent.prototype.updateResultColumnsDisplay = function () {
        // this.tableService.updateColumnsSmartDisplay(this.resultRows, this.resultColumns);
        // setTimeout(() => {
        this.resultColumns = this.tableService.extendTableFull(this.elemRef, this.resultTableId, this.resultColumns, true);
        this.resultColumns = this.resultColumns.map(function (i) { return i; });
        // });
    };
    // Update parsed results: 1.to database, 2.display on table
    FeatA3iComponent.prototype.updateParseResult = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var a3iOutputWithId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data) {
                            return [2 /*return*/];
                        }
                        a3iOutputWithId = [];
                        data.forEach(function (i) {
                            var ids = [];
                            _this.sourceRows.forEach(function (r, idx) {
                                if (i[_this.inputAddrCol] === r[_this.inputAddrCol] && !r[_this.updateCol]) {
                                    ids.push(r[_this.idCol]);
                                    r[_this.resultCol] = i;
                                    r[_this.parseCodeCol] = i[_this.parseCodeCol];
                                    var resultRow_1 = _this.resultRows[idx];
                                    Object.keys(i).forEach(function (key) { return resultRow_1[key] = i[key]; });
                                }
                            });
                            a3iOutputWithId.push({
                                output: i,
                                ids: ids
                            });
                        });
                        // Display parse result on table
                        // this.tableService.updateColumnsSmartDisplay(this.resultRows, this.resultColumns);
                        setTimeout(function () {
                            _this.updateResultColumnsDisplay();
                            // this.resultColumns = this.tableService.extendTableFull(this.elemRef, this.resultTableId, this.resultColumns, true);					
                            // this.resultColumns = this.resultColumns.map(i => i);
                        });
                        // Update parse result to database
                        return [4 /*yield*/, this.a3iService.updateA3iParseResult(this.selectedLayer.id, a3iOutputWithId)];
                    case 1:
                        // Update parse result to database
                        _a.sent();
                        this.updateParseDisable();
                        this.updateSaveParseDisable();
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatA3iComponent.prototype.getData = function (pageNum) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedLayer, attrFilters, gfo, qaCodes, paging, randomId, isMapFilterOn, rsp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearTableData();
                        selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
                        if (!selectedLayer) {
                            return [2 /*return*/];
                        }
                        attrFilters = this.attrFilterService.attrFilters.getValue().filters;
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, attrFilters.filter(function (f) { return f && f.filter; }).map(function (f) { return f.filter; }));
                        qaCodes = this.mainDataService.getQaCodesFromFilterOptions();
                        paging = {
                            pageSize: this.pageSize
                        };
                        if (pageNum) {
                            paging.pageNumber = pageNum;
                        }
                        else {
                            paging.rowCount = 1;
                            paging.pageNumber = 1;
                        }
                        randomId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, randomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        isMapFilterOn = this.activityService.mapFilterBS.getValue().isOn;
                        if (!!isMapFilterOn) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.qcService.getQcFeatureReport(selectedLayer.id, qaCodes, gfo, paging)];
                    case 2:
                        rsp = _a.sent();
                        this.rowsAll = rsp.data;
                        this.mainDataService.addDataToStoredRecords(rsp.data, this.a3iService.uniqueIdCol);
                        // this.rowsAll.forEach(r => {
                        // 		// // Set unique id for internal use
                        // 		// r[this.a3iService.uniqueIdCol] = this.commonService.getRandomId();
                        // 	// Store the original data WITH id
                        // 	r[this.attrIndexService.originalDataKey] = JSON.parse(JSON.stringify(r))
                        // });
                        this.a3iService.clearEditsSubject.next();
                        //
                        this.filterRowsByParseCode();
                        if (paging.rowCount) {
                            this.setTablePaging(rsp.totalCount);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.setTablePaging(0);
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonService.setLoadingSpinner(false, randomId);
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatA3iComponent.prototype.parse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var prefix, addresses, filtered, spinnerId, rsp, successRate, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prefix = this.selectedLayer.category.colPrefix;
                        addresses = [];
                        filtered = this.sourceRows.filter(function (r) { return r[_this.checkCol]; });
                        filtered.forEach(function (r, idx) {
                            if (!_this.checkRowParsable(r)) {
                                return;
                            }
                            // const parts = [];
                            // this.lstStandardCols.forEach(c => {
                            // 	const part = r[`${prefix}_${c.colName.toLowerCase()}`];
                            // 	if (part) {
                            // 		parts.push(part.trim());
                            // 	}
                            // });
                            // const inputAddr = parts.join(' ').trim();
                            var inputAddr = _this.a3iService.combinePartsToAddress(_this.lstStandardCols, prefix, r);
                            r[_this.inputAddrCol] = inputAddr;
                            _this.resultRows[idx][_this.inputAddrCol] = inputAddr;
                            addresses.push(inputAddr);
                        });
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.a3iService.parseAddress(addresses, this.userService.customerInfo.givState)];
                    case 2:
                        rsp = _a.sent();
                        return [4 /*yield*/, this.updateParseResult(rsp.data)];
                    case 3:
                        _a.sent();
                        successRate = this.calculateSuccessRate(rsp.data);
                        this.toastr.success("Successfully parsed. Success Rate: " + successRate + "%");
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        console.log(err_2);
                        this.toastr.error('Failed.');
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatA3iComponent.prototype.calculateSuccessRate = function (results) {
        var _this = this;
        var successAmount = results.filter((function (item) { return item[_this.parseCodeCol] == 's'; })).length;
        var allAmount = results.length;
        var successRate = Math.ceil(successAmount / allAmount * 100);
        return successRate;
    };
    FeatA3iComponent.prototype.saveParseResult = function () {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, ids, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        ids = this.sourceRows.filter(function (i) { return i[_this.checkCol] && _this.checkRowCommitable(i); }).map(function (i) { return i[_this.idCol]; });
                        if (!ids.length) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.a3iService.updateNenaPartsByA3i(this.selectedLayer.id, ids)];
                    case 2:
                        _a.sent();
                        this.toastr.success('Successfully committed');
                        return [4 /*yield*/, this.getData(this.pageNumber)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_3 = _a.sent();
                        console.log(err_3);
                        this.toastr.error('Failed.');
                        return [3 /*break*/, 6];
                    case 6:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatA3iComponent.prototype.checkRowParsable = function (row) {
        if (row[this.updateCol] || row[this.resultCol]) {
            return false;
        }
        return true;
    };
    FeatA3iComponent.prototype.checkRowCommitable = function (row) {
        if (!row[this.updateCol] && row[this.resultCol]) {
            return true;
        }
        return false;
    };
    FeatA3iComponent.prototype.updateParseDisable = function () {
        var _this = this;
        var disabled = !this.sourceRows.filter(function (r) { return r[_this.checkCol]; }).find(function (r) { return _this.checkRowParsable(r); });
        if (disabled !== this.a3iService.parseDisableBS.getValue().disabled) {
            this.a3iService.parseDisableBS.next({
                disabled: disabled
            });
        }
    };
    FeatA3iComponent.prototype.updateSaveParseDisable = function () {
        var _this = this;
        var disabled = !this.sourceRows.filter(function (r) { return r[_this.checkCol]; }).find(function (r) { return _this.checkRowCommitable(r); });
        if (disabled !== this.a3iService.saveParseDisableBS.getValue().disabled) {
            this.a3iService.saveParseDisableBS.next({
                disabled: disabled
            });
        }
    };
    FeatA3iComponent.prototype.initColumns = function (layer) {
        return __awaiter(this, void 0, void 0, function () {
            var prefix, standardSchema, sourceColumns_nena, sourceColumns_legacy, resultColumns, editColumns, nguidStandardCol, msag, esn, masgWidth, esnWidth, msagStandardCol, esnStandardCol, msagLeft_1, msagRight_1, msagStandardColLeft, msagStandardColRight, esnLeft_1, esnRight_1, esnStandardColLeft, esnStandardColRight;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedLayer = layer;
                        prefix = layer.category.colPrefix;
                        this.updateCol = prefix + "_" + this.attrIndexService.a3iUpdateColName;
                        this.resultCol = prefix + "_" + this.attrIndexService.a3iResultColName;
                        this.idCol = prefix + "_" + this.attrIndexService.idColName;
                        standardSchema = layer.category.standardCols;
                        if (!!standardSchema) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fieldMappingService.getStandardSchema(layer.category.id)];
                    case 1:
                        standardSchema = _a.sent();
                        layer.category.standardCols = standardSchema;
                        _a.label = 2;
                    case 2:
                        // Columns
                        this.lstStandardCols = this.a3iService.getLstStandardCols(standardSchema); // standardSchema.filter(c => c.colName.toLowerCase().startsWith('lst_'));
                        this.stStandardCols = this.a3iService.getStStandardCols(standardSchema);
                        sourceColumns_nena = [];
                        sourceColumns_legacy = [];
                        resultColumns = [];
                        editColumns = [];
                        // Check col
                        this.addCol(this.checkCol, ' ', [sourceColumns_nena, sourceColumns_legacy, resultColumns], null, this.checkCellTempl, true, this.checkboxHeaderTempl);
                        // Parse code col
                        this.addCol(this.parseCodeCol, ' ', [sourceColumns_nena, sourceColumns_legacy, resultColumns], null, this.parseCodeCellTempl, true);
                        nguidStandardCol = standardSchema.find(function (c) { return c.colName.toLowerCase() === _this.attrIndexService.nguidCol.toLowerCase(); });
                        this.nguidCol = prefix + "_" + nguidStandardCol.colName.toLowerCase();
                        this.addCol(this.nguidCol, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], nguidStandardCol, this.commonTemplateService.nguidCellTemplate, true, this.headerTempl, nguidStandardCol.htmlTooltip, 40);
                        msag = this.attrIndexService.msagColName;
                        esn = this.attrIndexService.esnColName;
                        masgWidth = 80;
                        esnWidth = 70;
                        if (layer.category.code === this.attrIndexService.cateCodeAddress) {
                            msagStandardCol = standardSchema.find(function (c) { return c.colName.toLowerCase() === msag; });
                            this.addCol(prefix + "_" + msag, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], msagStandardCol, null, true, this.headerTempl, msagStandardCol.htmlTooltip, masgWidth);
                            esnStandardCol = standardSchema.find(function (c) { return c.colName.toLowerCase() === esn; });
                            this.addCol(prefix + "_" + esn, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], esnStandardCol, null, true, this.headerTempl, esnStandardCol.htmlTooltip, esnWidth);
                        }
                        else if (layer.category.code === this.attrIndexService.cateCodeCenterline) {
                            msagLeft_1 = msag + '_l';
                            msagRight_1 = msag + '_r';
                            msagStandardColLeft = standardSchema.find(function (c) { return c.colName.toLowerCase() === msagLeft_1; });
                            msagStandardColRight = standardSchema.find(function (c) { return c.colName.toLowerCase() === msagRight_1; });
                            this.addCol(prefix + "_" + msagLeft_1, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], msagStandardColLeft, null, true, this.headerTempl, msagStandardColLeft.htmlTooltip, masgWidth);
                            this.addCol(prefix + "_" + msagRight_1, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], msagStandardColRight, null, true, this.headerTempl, msagStandardColRight.htmlTooltip, masgWidth);
                            esnLeft_1 = esn + '_l';
                            esnRight_1 = esn + '_r';
                            esnStandardColLeft = standardSchema.find(function (c) { return c.colName.toLowerCase() === esnLeft_1; });
                            this.addCol(prefix + "_" + esnLeft_1, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], esnStandardColLeft, null, true, this.headerTempl, esnStandardColLeft.htmlTooltip, esnWidth);
                            esnStandardColRight = standardSchema.find(function (c) { return c.colName.toLowerCase() === esnRight_1; });
                            this.addCol(prefix + "_" + esnRight_1, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], esnStandardColRight, null, true, this.headerTempl, esnStandardColRight.htmlTooltip, esnWidth);
                        }
                        this.lstStandardCols.forEach(function (c) {
                            _this.addCol(prefix + "_" + c.colName.toLowerCase(), null, [sourceColumns_legacy, editColumns], c, null, null, _this.headerTempl, c.htmlTooltip);
                        });
                        this.stStandardCols.forEach(function (c) {
                            var colResult = _this.addCol(c.colName.toLowerCase(), null, [resultColumns], c, null, null, _this.headerTempl, c.htmlTooltip);
                            //
                            var colSource = _this.addCol(prefix + "_" + c.colName.toLowerCase(), null, [sourceColumns_nena, editColumns], c, null, null, _this.headerTempl, c.htmlTooltip);
                            colSource.cellClass = _this.setCellClass;
                            colSource.info.matchingResultCol = colResult.prop;
                        });
                        this.sourceColumns_nena = sourceColumns_nena;
                        this.sourceColumns_legacy = sourceColumns_legacy;
                        this.setSourceColumnsByType();
                        this.resultColumns = resultColumns;
                        this.a3iService.a3iEditColumnsBS.next({
                            columns: editColumns
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatA3iComponent.prototype.addCol = function (prop, name, addTo, standardSchema, cellTempl, skipSmartDisplay, headerTempl, tooltip, width) {
        var col = this.tableService.setNewColumn(prop, name, {
            width: width || 30,
            align: 'C'
        });
        if (skipSmartDisplay) {
            col.info.skipSmartDisplay = true;
        }
        if (cellTempl) {
            col.cellTemplate = cellTempl;
        }
        if (headerTempl) {
            col.headerTemplate = headerTempl;
        }
        if (tooltip) {
            col.info.tooltip = tooltip;
        }
        if (standardSchema) {
            col.info.isUppercase = standardSchema.isUppercase;
        }
        addTo.forEach(function (i) { return i.push(col); });
        return col;
    };
    FeatA3iComponent.prototype.ngOnInit = function () {
        this.selectedParseCode = this.parseCodes[0];
        this.inputAddrCol = this.attrIndexService.parseInputAddrCol;
    };
    FeatA3iComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var layer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data) {
                            return [2 /*return*/];
                        }
                        layer = data.layer;
                        this.a3iService.uniqueIdCol = layer.category.colPrefix + '_' + this.attrIndexService.globalIdColStandard;
                        return [4 /*yield*/, this.initColumns(layer)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getData()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.selectedRecordA3iSub = this.a3iService.selectedRecordA3iBS.subscribe(function (data) {
            if (data.source === 'table') {
                return;
            }
            if (data.record) {
                var id_2 = _this.a3iService.getRecordId(data.record);
                var sourceRow = _this.sourceRows.find(function (r) { return _this.a3iService.getRecordId(r) === id_2; });
                var resultRow = _this.resultRows.find(function (r) { return _this.a3iService.getRecordId(r) === id_2; });
                if (sourceRow) {
                    _this.selectedSourceRows = [sourceRow];
                }
                else {
                    _this.selectedSourceRows = [];
                }
                if (resultRow) {
                    _this.selectedResultRows = [resultRow];
                }
                else {
                    _this.resultRows = [];
                }
            }
            else {
                _this.selectedResultRows = [];
                _this.selectedSourceRows = [];
            }
        });
        this.parseSub = this.a3iService.parseSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.parse()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.saveParseSub = this.a3iService.saveParseSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.saveParseResult()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.commitSub = this.a3iService.commitSubject.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var current_1, selectedRecord;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(data.state === 'done')) return [3 /*break*/, 2];
                        current_1 = this.selectedSourceRows[0];
                        return [4 /*yield*/, this.getData(this.pageNumber)];
                    case 1:
                        _a.sent();
                        if (current_1) {
                            selectedRecord = this.sourceRows.find(function (r) { return _this.a3iService.getRecordId(r) === _this.a3iService.getRecordId(current_1); });
                            this.a3iService.selectedRecordA3iBS.next({
                                record: selectedRecord
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    FeatA3iComponent.prototype.ngOnDestroy = function () {
        this.selectedLayerSub.unsubscribe();
        this.selectedRecordA3iSub.unsubscribe();
        this.parseSub.unsubscribe();
        this.saveParseSub.unsubscribe();
        this.commitSub.unsubscribe();
    };
    return FeatA3iComponent;
}());
export { FeatA3iComponent };
